import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';

const ROLE_OPTIONS = [
  { value: 'VIEWER', label: 'Viewer' },
  { value: 'TENANT_ADMIN', label: 'Tenant Admin' }
];

const INITIAL_FORM = {
  Email: '',
  FirstName: '',
  LastName: '',
  RoleName: 'VIEWER'
};

const AdminInviteUserModal = ({ show, onHide, onSubmit, sending }) => {
  const [formData, setFormData] = useState(INITIAL_FORM);

  useEffect(() => {
    if (show) {
      setFormData(INITIAL_FORM);
    }
  }, [show]);

  const updateField = key => e => {
    setFormData(current => ({
      ...current,
      [key]: e.target.value
    }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    onSubmit({
      Email: formData.Email.trim(),
      FirstName: formData.FirstName.trim(),
      LastName: formData.LastName.trim(),
      RoleName: formData.RoleName
    });
  };

  return (
    <Modal show={show} onHide={() => !sending && onHide()} centered>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton={!sending}>
          <Modal.Title>Invite User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>
              Email <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="email"
              value={formData.Email}
              onChange={updateField('Email')}
              placeholder="name@example.com"
              disabled={sending}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>
              First Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              value={formData.FirstName}
              onChange={updateField('FirstName')}
              disabled={sending}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>
              Last Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              value={formData.LastName}
              onChange={updateField('LastName')}
              disabled={sending}
              required
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>
              Role <span className="text-danger">*</span>
            </Form.Label>
            <Form.Select
              value={formData.RoleName}
              onChange={updateField('RoleName')}
              disabled={sending}
              required
            >
              {ROLE_OPTIONS.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => onHide()}
            disabled={sending}
          >
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={sending}>
            {sending ? (
              <Spinner animation="border" size="sm" className="me-1" />
            ) : null}
            Invite User
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

AdminInviteUserModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  sending: PropTypes.bool
};

AdminInviteUserModal.defaultProps = {
  sending: false
};

export default AdminInviteUserModal;
